import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'
import CLIENT_ROUTES from '../../../constants/client-endpoints'

export default () => {
    const { isAdmin, isFacilitator } = useCurrentUser()
    const { toLocation } = useClientLocation()
    const url = `${CLIENT_ROUTES.EXPERIENCE.replace(':experienceId', 'new')}${CLIENT_ROUTES.EDIT}`;

    const isCreatePermitted = isAdmin || isFacilitator;
    const createCourse = () => toLocation(url);

    return {
        isCreatePermitted,
        createCourse
    };
};
